export const getAPIHostnameForUIDomain = ({
  uiHostname,
}: {
  uiHostname: string;
}): {
  apiHostname: string;
  apiDomain: string;
  baseDomain: string;
} => {
  const domainWithoutWWWOrScheme = uiHostname
    .toLowerCase()
    .replace(/^https?:\/\//, '') // Remove scheme (http:// or https://)
    .replace(/^www\./, ''); // Remove www. if present

  // if the uiDomain starts with 'ui.'
  // so this will turn ui.anthony.sigma2-dev.com into api.anthony.sigma2-dev.com
  if (domainWithoutWWWOrScheme.startsWith('ui.')) {
    const withoutUi = domainWithoutWWWOrScheme.slice(3);
    const apiDomain = `api.${withoutUi}`;

    return {
      apiHostname: `https://${apiDomain}`,
      apiDomain,
      baseDomain: withoutUi,
    };
  }

  // if it is localhost:[something], then return http://localhost:8079
  if (domainWithoutWWWOrScheme.startsWith('localhost')) {
    const domainPart = 'localhost:8079';
    return {
      apiHostname: `http://${domainPart}`,
      apiDomain: domainPart,
      baseDomain: 'localhost',
    };
  }

  // lastly, just return the API subdomain, for cases like heartlandqa.heartland.sigmasquared.io -> api.heartlandqa.heartland.sigmasquared.io
  const apiDomain = `api.${domainWithoutWWWOrScheme}`;
  return {
    apiHostname: `https://${apiDomain}`,
    apiDomain,
    baseDomain: domainWithoutWWWOrScheme,
  };
};
